<template>
  <div class="repaymentBox">
    <div class="headInfoBox">
      <Header :homePage="true" />
      <h5>Un gusto poder saludarte</h5>
      <h5>Cuentas con un pago pendiente de tu préstamo</h5>
      <!-- repay Detail Info -->
      <div class="repayDetail">
        <div style="margin-bottom:0.4rem">
          <p>Fecha de pago</p>
          <h3>{{ $setMoment(repay_time, 1, 1) }}</h3>
        </div>
        <div>
          <p>Resto por pagar</p>
          <h3>S/{{ $setNum(unpaid_amount) }}</h3>
        </div>
      </div>
      <a @click="jumpDetail">Detalles de la tarifa de su préstamo</a>
    </div>
    <!-- repayment Amount -->
    <div class="repayAmontBox">
      <h5>Por favor ingrese el monto solicitado del reembolso</h5>
      <van-field
        @input="changeAmount"
        v-model="acctAmount"
        type="digit"
        label="S/"
      />
      <p class="repayTip">{{ descText }}</p>
    </div>
    <!-- repayment Bnak choose -->
    <div class="bankListBox">
      <el-radio-group v-model="chooseBank" @change="changeRadio">
        <el-radio
          v-for="(item, index) in bankList"
          :key="index"
          :label="item.channelList[0].name"
        >
          <template>
            <img :src="item.channelList[0].logo" alt="" />
            {{ item.channelList[0].name }}
          </template>
        </el-radio>
      </el-radio-group>
    </div>
    <!-- repayment Btn -->
    <div @click="subRepayment" class="subRepayment">
      Realice su pago en estos momentos（{{ totalAmount }}）
    </div>
    <ContactOrAbout />
    <!-- repayment Detail -->
    <van-popup
      closeable
      class="detailBox"
      round
      v-model="detailShow"
      position="bottom"
    >
      <div>
        <h3>
          Detalles del préstamo
        </h3>
        <ul class="loadDetail">
          <li>
            <p>Fecha de vencimiento</p>
            <p>{{ $setMoment(reloanInfo.repay_time, 1, 1) }}</p>
          </li>
          <li>
            <p>Monto de depósito</p>
            <p>S/ {{ $setNum(reloanInfo.loan_amount) }}</p>
          </li>
          <li>
            <p>Monto de pago</p>
            <p>S/ {{ $setNum(reloanInfo.total_amount_due) }}</p>
          </li>
          <li>
            <p>Interés</p>
            <p>S/ {{ $setNum(reloanInfo.interest) }}</p>
          </li>
          <li>
            <p>Cargo de servicios</p>
            <p>S/ {{ $setNum(reloanInfo.service_fee) }}</p>
          </li>
          <li>
            <p>IGV</p>
            <p>S/ {{ $setNum(reloanInfo.vat) }}</p>
          </li>
        </ul>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Header from "./components/header.vue";
import ContactOrAbout from "./components/contactOrAbout.vue";
import {
  repayMentInfo,
  createRepayment,
  repaymentDesc,
  getRepaymentList,
} from "../utils/api/h5page";
export default {
  name: "",
  components: {
    Header,
    ContactOrAbout,
  },
  props: {},
  data() {
    return {
      detailShow: false,
      repay_time: "",
      unpaid_amount: 0,
      acctAmount: "",
      chooseBank: "",
      chooseBankData: {},
      bankList: [],
      getFees: null,
      descText: "",
      totalAmount: 0,
      orderId: "",
      reloanInfo: {},
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.getRpaymentInfo();
    this.repaymentList();
  },
  methods: {
    // catch repayment Detail
    jumpDetail() {
      this.detailShow = true;
    },

    // submit Btn
    subRepayment() {
      if (!this.acctAmount) {
        return this.$Toast("Please fill in the repayment amount");
      }
      const params = {
        orderId: this.orderId,
        acctCouponId: -1,
        acctAmount: Number(this.acctAmount),
        ...this.chooseBankData,
      };
      this.$emit("openLoading");
      createRepayment(params).then(({ data }) => {
        if (data.code == 0) {
          window.location.href = data.data.token;
        } else {
          this.$emit("closeLoading");
        }
      });
    },

    changeAmount() {
      if (this.acctAmount > this.unpaid_amount) {
        this.acctAmount = this.unpaid_amount;
      }
      if (this.getFees) clearTimeout(this.getFees);
      this.getFees = setTimeout(() => {
        this.computDesc();
      }, 500);
    },

    // 计算手续费
    computDesc() {
      repaymentDesc({
        ...this.chooseBankData,
        payAmount: Number(this.acctAmount),
      }).then(({ data }) => {
        console.log(data);
        this.descText = data.data.desc;
        this.totalAmount = data.data.totalAmount;
        clearTimeout(this.getFees);
      });
    },

    // 获取还款信息
    getRpaymentInfo() {
      repayMentInfo().then(({ data }) => {
        console.log(data);
        this.unpaid_amount = data.data.info.unpaid_amount;
        this.acctAmount = this.unpaid_amount;
        this.repay_time = data.data.info.repay_time;
        this.reloanInfo = data.data.info;
        this.orderId = data.data.info.order_id.toString();
      });
    },

    // 获取还款通道
    repaymentList() {
      getRepaymentList().then(({ data }) => {
        if (data.code == 0) {
          this.bankList = data.data.channelInfo;
          // 银行卡默认选择第一个
          this.chooseBankData.payType = this.bankList[0].payType;
          this.chooseBankData.channelNo = this.bankList[0].channelList[0].channelNo;
          this.chooseBank = this.bankList[0].channelList[0].name;
          console.log(this.chooseBank);
        } else {
          // this.$Toast(data.message);
        }
      });
    },

    // 更换还款通道
    changeRadio(val) {
      this.bankList.map((item) => {
        if (val == item.channelList[0].name) {
          this.chooseBankData.payType = item.payType;
          this.chooseBankData.channelNo = item.channelList[0].channelNo;
        }
      });
      setTimeout(() => {
        this.computDesc();
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.repaymentBox {
  padding: 0 0.2rem 0.5rem;
  background: #f5f5f5;
}

.headInfoBox {
  width: calc(100% + 0.4rem);
  padding: 0 0.2rem;
  margin-left: -0.2rem;
  height: 6.7rem;
  background: url("./assets/images/pageBgc.png") no-repeat;
  background-size: 100% 100%;
  h5 {
    font-family: Roboto, Roboto;
    font-weight: 700;
    font-size: 0.25rem;
    color: #333333;
    margin: 0.24rem 0 0.27rem;
  }
  .repayDetail {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 2.6rem;
    background: #ffffff;
    border-radius: 0.2rem;
    div {
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 0 0.4rem;
      p {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 0.32rem;
        color: #333333;
      }
      h3 {
        font-family: Roboto, Roboto;
        font-weight: 700;
        font-size: 0.4rem;
        color: #333333;
      }
    }
  }
  a {
    display: block;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.32rem;
    color: #666666;
    text-decoration: underline;
    text-align: right;
    margin: 0.34rem 0;
  }
}

.repayAmontBox {
  width: 100%;
  background-color: #fff;
  padding: 0.44rem 0.3rem 0.3rem;
  border-radius: 0.2rem;
  h5 {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.24rem;
    color: #333333;
    margin-bottom: 0.26rem;
  }
  .van-cell {
    border-bottom: 0.01rem solid #efefef;
    padding: 0 0 0.2rem;
  }
  /deep/ .van-field__label {
    width: auto;
    font-family: Roboto, Roboto;
    font-weight: 700;
    font-size: 0.52rem;
    color: #333333;
    line-height: normal;
  }
  /deep/ .van-field__control {
    font-family: Roboto, Roboto;
    font-weight: 700;
    font-size: 0.52rem;
    color: #333333;
  }
  .repayTip {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.24rem;
    color: #666666;
    margin-top: 0.1rem;
  }
}

.bankListBox {
  width: 100%;
  padding: 0.3rem 0.24rem 0.32rem;
  background: #ffffff;
  border-radius: 0.2rem;
  margin: 0.4rem 0;
  img {
    width: 0.6rem;
    height: 0.6rem;
    margin-right: 0.15rem;
  }
}

.subRepayment {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 5.8rem;
  height: 0.8rem;
  background: #c90000;
  box-shadow: inset 0rem 0.16rem 0.32rem 0rem rgba(255, 255, 255, 0.22);
  border-radius: 0.4rem;
  margin: 0 auto 0.19rem;
  font-family: Roboto, Roboto;
  font-weight: 500;
  font-size: 0.23rem;
  color: #ffffff;
}
.el-radio-group {
  width: 100%;
}
.el-radio {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  margin-bottom: 0.34rem;
  &:last-child {
    margin-bottom: 0;
  }
}
/deep/ .el-radio__label {
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 0.26rem;
  color: #666666;
  display: flex;
  align-items: center;
}
/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #666666;
}
/deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #c90000;
  background: #fff;
}
/deep/ .el-radio__inner::after {
  width: 0.14rem;
  height: 0.15rem;
  background-color: #c90000;
}
/deep/ .el-radio.is-bordered.is-checked {
  border-color: #c90000;
}

.detailBox {
  padding: 0.3rem 0.25rem;
  h3 {
    font-family: Roboto, Roboto;
    font-weight: 700;
    font-size: 0.32rem;
    color: #333333;
    margin-bottom: 0.15rem;
  }
}
.loadDetail {
  li {
    display: flex;
    justify-content: space-between;
    padding: 0.15rem 0.24rem;
    p {
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 0.26rem;
      color: #333333;
    }
  }
}
</style>
